import axios, { CancelTokenSource } from "axios";
import { HTTPMethod } from "./helper";
import axiosApi from "./guard";

// Map to store cancel tokens for each path
const cancelTokens = new Map<string, CancelTokenSource>();

const API_URL = process.env.REACT_APP_API_URL;

export async function getDocJson(): Promise<apiDoc> {
  const response = await axios[HTTPMethod.GET](API_URL + '/docs.json', {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  return response.data;
}

export function getDocJsonLD() {
  return apiCall(HTTPMethod.GET, '/docs.jsonld');
}

export async function apiCall(
  method: HTTPMethod,
  path: string,
  data?: any,
  cache = false,
  cancelPrevious = false
) {
  // If cancelPrevious is true, cancel any existing request to the same path
  if (cancelPrevious) {
    const existingToken = cancelTokens.get(path);
    if (existingToken) {
      existingToken.cancel('Request canceled - new request started');
      cancelTokens.delete(path);
    }
  }

  // Create a new cancel token for this request
  const source = axios.CancelToken.source();
  if (cancelPrevious) {
    cancelTokens.set(path, source);
  }

  let http = axiosApi(cache);

  try {
    // Make the request with proper typing for each HTTP method
    let response;
    // Set default data empty object if not provided
    data = data || {};
    if (method === HTTPMethod.GET) {
      data.cancelToken = source.token;
      response = await http.get(`${API_URL}${path}`, {...data});
    } else {
      response = await http[method](`${API_URL}${path}`, JSON.stringify(data));
    }
    
    // Clean up the cancel token if this was the last request
    if (cancelPrevious) {
      cancelTokens.delete(path);
    }
    
    return response;
  } catch (error) {
    // If the error is from cancellation, rethrow a clean error
    if (axios.isCancel(error)) {
      throw new Error('Request was canceled');
    }
    // Clean up on error if this was a cancelable request
    if (cancelPrevious) {
      cancelTokens.delete(path);
    }
    throw error;
  }
}
export async function apiCallFile(method: HTTPMethod, path: string, params?: any, cache = false) {
  let http = axiosApi(cache);
  return await http[method](`${API_URL}${path}`, params, {
    headers: {
      'accept': 'application/ld+json',
      'Content-Type': 'multipart/form-data'
    }
  });
}
